import React from 'react';

interface DividerProps {
  data: {
    id?: string;
    style?: string;
    [key: string]: unknown;
  };
  styles?: string;
}

export const Divider: React.FC<DividerProps> = ({ data: _data, styles: _styles }) => (
  <div className="">
    <hr className="border-gray-300" />
  </div>
);
